import type { ContactConversation } from '../../app/legacy-types';
import { ChannelMark, ConversationAvatar } from './ChannelIdentity';
import {
  channelLabel,
  formatContactDateTime,
} from './contactCenterModel';

export function CustomerPanel({ conversation }: { conversation: ContactConversation }) {
  return <section className="surface contact-info-card contact-customer-panel">
    <div className="surface-head compact"><div><h2>Собеседник</h2><p>Контактные данные и история</p></div></div>
    <div className="contact-center-v3-client">
      <ConversationAvatar provider={conversation.provider} name={conversation.customer_name || conversation.title || 'Собеседник'} />
      <span><b>{conversation.customer_name || conversation.title}</b><small><ChannelMark provider={conversation.provider} /> {channelLabel(conversation.provider)}</small></span>
    </div>
    <div className="contact-client-grid">
      <div><small>Имя</small><b>{conversation.customer_name || conversation.title}</b></div>
      {conversation.customer_username && <div><small>Ник</small><b>{conversation.customer_username}</b></div>}
      {conversation.customer_phone && <div><small>Телефон</small><b>{conversation.customer_phone}</b></div>}
      <div><small>Внешний идентификатор</small><b>{conversation.customer_external_id || '—'}</b></div>
      <div><small>Канал</small><b>{channelLabel(conversation.provider)}</b></div>
      {conversation.linked_company_name && <div><small>Компания</small><b>{conversation.linked_company_name}</b></div>}
      {conversation.linked_contact_name && <div><small>Контакт</small><b>{conversation.linked_contact_name}</b></div>}
      <div><small>Первое обращение</small><b>{formatContactDateTime(conversation.created_at)}</b></div>
      <div><small>Последняя активность</small><b>{formatContactDateTime(conversation.last_message_at)}</b></div>
    </div>
  </section>;
}
